import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import UpdateLuckyWheelListing from '@/modules/promotion/components/UpdateLuckyWheel/components/UpdateLuckyWheelListing'

function UpdateLuckyWheelPage() {
	return (
		<PageContainer>
			<UpdateLuckyWheelListing />
		</PageContainer>
	)
}

const GuardedUpdateLuckyWheelPage = withUserPermission(UpdateLuckyWheelPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_LUCKY_WHEEL],
})

export default GuardedUpdateLuckyWheelPage
